import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Size, SizeHeightMappings } from "@type/sizing";
import { StyledChipProps, StyledSuffixContainerProps } from "./chip.types";

export const StyledChip = styled.button<StyledChipProps>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    border-radius: 4px;
    height: ${({ size }) =>
        SizeHeightMappings[size ? Size[size] : Size.medium]};
    padding-inline: ${({ hasPrefix, hasSuffix, token }) => {
        const paddingLeft =
            hasPrefix || hasSuffix
                ? token.spacing.spacing100
                : token.spacing.spacing200;

        let paddingRight = token.spacing.spacing200;
        if (hasSuffix) {
            paddingRight = token.spacing.spacing50;
        } else if (hasPrefix) {
            paddingRight = token.spacing.spacing100;
        }
        return `${paddingLeft} ${paddingRight}`;
    }};
    min-width: max-content;

    ${({ token }) => {
        return css`
            background: ${token.colorWhite};
            color: ${token.color.text.default};
            border: 1px solid ${token.color.border.default};
            font-family: ${token.fontFamily};
            font-size: ${token.fontSize}px;
            line-height: ${token.lineHeightLG};
        `;
    }}
    ${({ hasSuffix, hasOnClick, disabled, selected, token }) => {
        if (disabled) {
            return css`
                color: ${token.color.text.textDisabled};
                border-color: ${token.color.border.borderDisabled};
                background: ${token.color.bg.fill.fillDisabled};
                cursor: not-allowed;
            `;
        }

        if (selected) {
            return css`
                border-color: ${token.color.border.borderPrimaryBold};
                background: ${token.color.bg.fill.fillPrimarySubtler};
            `;
        }

        if (hasSuffix && !hasOnClick) {
            return css`
                cursor: default;
            `;
        }

        return css`
            :hover {
                border-color: ${token.color.border.borderPrimaryBold};
            }
        `;
    }};
`;

export const StyledSuffixContainer = styled.span<StyledSuffixContainerProps>`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s;

    ${({ disabled }) => {
        if (disabled) {
            return css`
                cursor: not-allowed;
            `;
        }

        return css`
            :hover {
                opacity: 1;
            }
        `;
    }}
`;

export const StyledChipGroup = styled.div`
    display: flex;
    gap: 12px;
`;
